import { stack } from "@styled-system/patterns";

export const inputsWrapperClass = stack({
	gap: "12",
});
